// glimpseFilesHooks.js - Custom hooks for filteredFiles functionality
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOriginalTime } from "../originalTime";

import {
  reset,
  setActiveFilteredFiles,
  setClipTimeFilteredFiles,
  setPlayStateFilteredFiles,
  setVolumeFilteredFiles,
} from ".";

export const useGlimpsedFiles = () => {
  const dispatch = useDispatch();
  const filteredFiles = useSelector((state) => state.filteredFiles);

  // Set active file ID
  const handleActiveFile = useCallback(
    (activeFileId) => {
      return dispatch(setActiveFilteredFiles(activeFileId));
    },
    [dispatch],
  );

  // Set clip time
  const handleClipTime = useCallback(
    (clipTime, clip) => {
      let originalTime = clipTime;

      if (clip?.timeMappings) {
        originalTime = getOriginalTime(clip.timeMappings, clipTime);
      }

      return dispatch(
        setClipTimeFilteredFiles({
          clipTime,
          originalTime,
        }),
      );
    },
    [dispatch],
  );

  // Set play state
  const handlePlayState = useCallback(
    (playState) => {
      return dispatch(setPlayStateFilteredFiles(playState));
    },
    [dispatch],
  );

  // Reset glimpsed files state
  const handleReset = useCallback(() => {
    return dispatch(reset());
  }, [dispatch]);

  // Set volume
  const handleVolume = useCallback(
    (volume) => {
      return dispatch(setVolumeFilteredFiles(volume));
    },
    [dispatch],
  );

  return {
    // State
    activeFileId: filteredFiles.activeFileId,
    clipTime: filteredFiles.clipTime,
    originalTime: filteredFiles.originalTime,
    playState: filteredFiles.playState,
    volume: filteredFiles.volume,

    // Actions
    reset: handleReset,
    setActiveFilteredFiles: handleActiveFile,
    setClipTimeFilteredFiles: handleClipTime,
    setPlayStateFilteredFiles: handlePlayState,
    setVolumeFilteredFiles: handleVolume,
  };
};
